import React from "react";
import {
  AutocompleteInput,
  Edit,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "react-admin";

export const TenantEdit = props => (
  <Edit mutationMode="pessimistic" {...props}>
    <SimpleForm>
      <TextInput source="origin" autoFocus />
      <ReferenceInput source="tenantTypeId" reference="lists/tenant_types">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput source="dealerId" reference="dealers" allowEmpty>
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);
